// src/screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilesTable/LoanFilesTable.jsx
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useRef } from "react";

import isEmpty from "lodash/isEmpty";

import AgGridTableWrapper from "../../../../../components/agGrid/AgGridTableWrapper";
import Txt from "../../../../../components/typography/Txt";

import { Box } from "@mui/material";
import { isNil } from "lodash";
import CellRendererUserByEmail from "../../../../../components/agGrid/cellRenderer/CellRendererUserByEmail";

import CellRendererLoanFileActions from "./CellRendererLoanFileActions";
import { useColumnTypesLoanFilesTable, useGetRowId } from "./hooks";
import { useFileDocGroupAndTypesHook } from "../../../../../hooks/useFileDocGroupAndTypesHook";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanFilesExtractedTable = ({
  rowData,

  getRowStyle,
  onCellClicked,

  onRowClicked,

  quickFilter,

  sortFilter,
}) => {
  const gridRef = useRef(null);
  const { fileDocGroups, getDocTypesByGroup } = useFileDocGroupAndTypesHook();
  // Column definitions & types
  const columnDefs = useMemo(
    () => [
      {
        width: 155,
        maxWidth: 155,
        flex: 0,
        headerName: "Actions",
        resizable: false,
        cellStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: "0px",
          borderLeft: "none !important",
        },

        cellRenderer: (params) => {
          if (params.node.group) {
            return params.value;
          }
          return <CellRendererLoanFileActions params={params} />;
        },
      },
      {
        headerName: "Filename",
        field: "file_display_name",
        flex: 0,
        minWidth: 250,
        cellEditor: "agTextCellEditor",
        sort:
          sortFilter?.colId === "file_display_name" ? sortFilter?.sort : null,
      },

      {
        headerName: "Category",
        field: "docGroup",

        // sort: "asc",
        sort: isNil(sortFilter)
          ? "asc"
          : sortFilter?.colId === "docGroup"
            ? sortFilter?.sort
            : null,
        minWidth: 220,

        cellEditor: "agRichSelectCellEditor",
        valueGetter: (params) => {
          const value = params.data?.docGroup;
          return value === undefined || value === null || value === ""
            ? "Uncategorized"
            : value;
        },
        cellEditorParams: {
          values: fileDocGroups || [],
          allowTyping: true,
          filterList: true,
          highlightMatch: true,
          valueListMaxHeight: 220,
          valueListWidth: 620,
        },
      },
      {
        headerName: "Document Type",
        field: "docType",
        // sort: "asc",
        sort: isNil(sortFilter)
          ? "asc"
          : sortFilter?.colId === "docGroup"
            ? sortFilter?.sort
            : null,

        showRowGroup: "docType",

        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: (params) => {
          return {
            values: getDocTypesByGroup(params.data.docGroup),
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            valueListMaxHeight: 220,
            valueListWidth: 620,
          };
        },
      },
      // {
      //   headerName: "Associations",
      //   cellRenderer: CellRendererLoanFileAssociations,
      // },
      {
        headerName: "Parsed Date",
        field: "modifiedDate",

        type: "dateTime",
        wrapHeaderText: true,
        autoHeaderHeight: true,
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
      },
      {
        headerName: "Parsed By",
        field: "parsedBy",

        wrapHeaderText: true,
        autoHeaderHeight: true,
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
        cellRenderer: CellRendererUserByEmail,
      },
      // {
      //   headerName: " ",
      //   field: "preview",

      //   wrapHeaderText: true,
      //   autoHeaderHeight: true,

      //   cellRenderer: () => {
      //     return (
      //       <Button startIcon={<PhotoFilterOutlined />}>
      //         View Parsed Data
      //       </Button>
      //     );
      //   },
      // },
    ],
    [fileDocGroups, getDocTypesByGroup, sortFilter],
  );
  const columnTypes = useColumnTypesLoanFilesTable();
  const getRowId = useGetRowId();

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 100,
    };
  }, []);

  // const getRowStyle = useGetRowStyles();

  if (isEmpty(rowData)) {
    return (
      <Box sx={{ p: 3 }}>
        <Txt secondary>No parsed files found</Txt>
      </Box>
    );
  }

  return (
    <AgGridTableWrapper
      // height="500px"
      // height="100%"
      suppressMinHeightWhenPopulated={rowData}
      simpleTable
      size={4}
      sx={{
        // maxHeight: "80vh",
        width: "100%",
        height: "100%",

        //
      }}
    >
      <AgGridReact
        ref={gridRef}
        getRowId={getRowId}
        rowData={rowData}
        getRowStyle={getRowStyle}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        columnTypes={columnTypes}
        onCellClicked={onCellClicked}
        quickFilterText={quickFilter}
        onRowClicked={onRowClicked}
        domLayout={"autoHeight"}
        tooltipShowDelay={50}
        tooltipHideDelay={3000}
        tooltipMouseTrack
      />
    </AgGridTableWrapper>
  );
};

export default LoanFilesExtractedTable;
